import styled from 'styled-components';
import { getLoadingAnimation, parseColor, setAlpha } from '../../styles';
import { Box, type BoxProps } from '../Core';

export type SkeletonProps = BoxProps;

/** Animated loading component for UI elements. */
export const Skeleton = styled(Box)`
  ${({ theme }) =>
    getLoadingAnimation(theme, true, 'backgroundContent', setAlpha(0.5, parseColor(theme, 'backgroundContent') ?? ''))}
`;

/** Animated loading component for text elements. */
export const SkeletonText = styled(Skeleton).attrs<SkeletonProps>(({ h = '16px', w = '32px' }) => ({
  h,
  w,
}))`
  ${({ theme }) =>
    getLoadingAnimation(theme, true, 'backgroundCard', setAlpha(0.08, parseColor(theme, 'backgroundCard') ?? ''))};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  flex-shrink: 0;
`;

/** Animated loading component to cover an entire element. */
export const SkeletonLoader = styled(Skeleton)`
  inset: 0;
  position: absolute;
`;
